import moment from 'moment';

import utils from './lib/utils';

const toHumanDate = date => moment(date).format('l');
const toHumanDateTime = date => moment(date).format('lll');

const filters = {
  toHumanDate,
  toHumanDateTime,
  toCurrency: utils.toCurrency,
};

export default (Vue) => {
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
  });
};
